import {userMenu} from "../constants/menus";
import {PATH_META_MANAGER} from "../constants/paths";

export const isClassificationsServer = (username, permissions, anonymousPages, t) => {
    const metaManagerNode = userMenu(t).find(({path}) => path === PATH_META_MANAGER);

    return username !== null
        ? !permissions || !permissions.functionality || permissions.functionality.length !== 1
            ? false
            : metaManagerNode.children.map(({path}) => path.substr(path.lastIndexOf("/") + 1)).includes(permissions.functionality[0])
        : !anonymousPages || anonymousPages.length !== 1
            ? false
            : metaManagerNode.children.map(({path}) => path).includes(anonymousPages[0]);
};

export const isPageVisible = (permissions, anonymousPages, isRouting = true) => ({children, path, isDivider, fetchUrl }) => {
    if (!path) {
        return false;
    }
    let sanitizedPath = path.substring(path.lastIndexOf("/") + 1);
    if (sanitizedPath.includes("?")) {
        sanitizedPath = sanitizedPath.split("?")[0];
    }
    const hasChildren = children && children.length > 0;
    if (fetchUrl) {
        if (!hasChildren) {
            return isRouting;
        }
        if (hasChildren) {
            if (!!permissions && permissions.functionality) {
                return permissions.functionality.filter(page => page === sanitizedPath).length;
            }
        }
    }
    if (isDivider || hasChildren) {
        return true;
    }
    if (!!permissions && permissions.functionality) {
        return permissions.functionality.filter(page => page === sanitizedPath).length;
    }
    if (!!anonymousPages) {
        return !!anonymousPages.find(page => page.includes(path));
    }
    return false;

}

export const propertyIsDefined = (property) => {
    return property !== null && property !== undefined;
}